<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>DANH SÁCH LOẠI LỖI</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          v-if="dataPermission.includes('CNPS_DEVICE_INFO_ERROR_CREATE')"
          @click="create"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Thêm mới
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã lỗi/ Tên lỗi"
            />
          </div>

          <div class="form-group">
            <Select2 v-model="search.idDevice" :options="dataDevice" placeholder="Loại thiết bị" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeDevice"
              :options="Config.getSearch(Config.errorTypeDevice)"
              placeholder="Mức độ"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="Config.getSearch(Config.statusCatDevice)"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.creatorId"
              :options="Config.getSearch(dataManager)"
              placeholder="Người tạo"
            />
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(time)="data">
                <p>{{ data.item.createTime | formatDate('HH:mm, DD/MM/YYYY') }}</p>
              </template>
              <template #cell(creator)="data">
                <p>{{ data.item.creator ? data.item.creator.name : '' }}</p>
              </template>
              <template #cell(level)="data">
                <p>{{ data.item.typeDevice | transformData(Config.errorTypeDevice) }}</p>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="data.item.status">
                  {{ data.item.status | transformData(Config.statusCatDevice) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    v-if="dataPermission.includes('CNPS_DEVICE_INFO_ERROR_UPDATE')"
                    @click="editError(data.item)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataPermission.includes('CNPS_DEVICE_INFO_ERROR_CHANGE') &&
                      data.item.status === 'ACTIVE'
                    "
                    @click="changeActive(data.item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Khóa
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataPermission.includes('CNPS_DEVICE_INFO_ERROR_CHANGE') &&
                      data.item.status === 'LOCKED'
                    "
                    @click="changeActive(data.item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Mở lại
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import { StaffService } from '@/services/staff.service'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'time', label: 'Thời gian tạo', thStyle: 'min-width: 170px' },
    { key: 'code', label: 'Mã lỗi', thStyle: 'min-width: 250px' },
    { key: 'description', label: 'Tên lỗi', thStyle: 'min-width: 150px' },
    { key: 'name', label: 'Loại thiết bị', thStyle: 'min-width: 150px' },
    { key: 'creator', label: 'Người tạo', thStyle: 'min-width: 150px' },
    { key: 'level', label: 'Mức độ', thStyle: 'min-width: 150px' },
    { key: 'status', label: 'Trạng thái', thStyle: 'min-width: 150px' },
    { key: 'note', label: 'Ghi chú', thStyle: 'min-width: 150px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'warranty',
    data() {
      return {
        Config,
        fieldsTable,
        showLoading: false,
        filterTable: fieldsTable,
        tbLoading: false,
        lists: [],
        pagination: {
          total: 0,
        },
        search: {
          limit: 20,
          page: 1,
        },
        optionInventory: [],
        dataManager: [],
        dataDevice: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    created() {
      this.fetchData()
      DeviceService.typeDeviceConfig()
        .then(
          s => s.data?.map(s => ({ id: s.id, text: s.name, abbreviation: s.abbreviation })) ?? []
        )
        .then(
          s =>
            (this.dataDevice = [
              { id: 'OTHER', text: 'Thiết bị khác', abbreviation: 'OTHER' },
              ...s,
            ])
        )
      StaffService.getStaffByIdSuperior({ userId: this.dataUser.userId })
        .then(s => s.data?.map(s => ({ id: s.userId, text: `${s.name} - ${s.userName}` })) ?? [])
        .then(s => (this.dataManager = s))
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    methods: {
      preareData() {
        const data = cloneDeep(this.search)
        for (const key in data) {
          if (data[key] === '0') delete data[key]
        }
        if (data.idDevice) {
          const dataAbbreviation = this.dataDevice.find(item => item.id === data.idDevice)
          data.abbreviation = dataAbbreviation.abbreviation
        }
        delete data.idDevice
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await DeviceService.getListErrorType(params)
          if (response.code === 1000) {
            this.lists = response.data.infoErrorRes
            this.pagination.total = response.data.count
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message)
        } finally {
          this.tbLoading = false
        }
      },
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.fetchData()
      },
      create() {
        this.$router.push({ path: '/error-type/create' })
      },
      editError(data) {
        this.$router.push({ path: `/error-type/${data.id}` })
      },
      async changeActive(id) {
        try {
          this.showLoading = true
          const response = await DeviceService.changeStatusErrorType(id)
          if (response.code === 1000) {
            this.showSuccessMx('Đổi trạng thái lỗi thành công')
            this.fetchData()
          } else this.showFailMx(response.message)
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .ACTIVE {
    color: #fff;
    background-color: #28a745;
  }
</style>
